import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing devConfig for permission checks

/**
 * Class representing the FilterMachineRegisterView.
 * @extends JetView
 */
export default class FilterMachineRegisterView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Configuration for the ID input field
        const fecha = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Name of the input field
                    type: 'number', // Input type
                    label: _("<span class='icon-id'></span> ID"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('ID'), // Placeholder text
                    invalidMessage: _('ID'), // Invalid message for the field
                },
            ],
        };

        // Placeholder for player ID section
        const playerId = {
            margin: 5,
            rows: [],
        };

        // Placeholder for transaction ID section
        const transactionId = {
            margin: 5,
            rows: [],
        };

        // Upper section layout containing fecha and a spacer
        const upper_section = {
            cols: [
                fecha,
                { gravity: 2, minWidth: 50 }, // Spacer with gravity
            ],
        };

        // Configuration for the buttons section
        const buttons = {
            id: 'b2', // ID for the button container
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for spacing
                        {
                            view: 'button', // Button to add a machine
                            value: _('Añadir Máquina'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 150, // Conditional width based on screen size
                            minWidth: 200, // Minimum width of the button
                            hidden: !devConfig.getPermAction(
                                'machineRegisterAdd',
                                'Add', // Permission check for button visibility
                            ),
                            css: 'prm-machineRegisterAdd', // CSS class for styling
                            click: () => {
                                // Click event handler
                                this.show(
                                    'machine.addMachineManagement/machine.AddMachineRegister', // Navigation to add machine view
                                );
                            },
                        },
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clear the form fields
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter machines
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200, // Minimum width of the button
                            click: () => {
                                // Click event handler
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('machineRegister:filter', [
                                    filterdata, // Trigger filter event with form data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Form view
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('grav').hide(); // Hide the gravity element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
